export const PROVIDER_DEFAULT = null;
export const PROVIDER_GOOGLE = 'google';
